import { Professional, User_Professional_Public } from "@graphql/schema.types";
import { Calendar } from "@components/atoms/Calendar";
import dayjs from "dayjs";
import { useTranslation } from "@refinedev/core";
import { useState } from "react";

type ProfessionalPublicCalendar = Professional & {
    user_professional_public: User_Professional_Public
}

interface DateSelectionProps {
    selectedProfessional: ProfessionalPublicCalendar | undefined;
    selectedDate: dayjs.Dayjs;
    onDateSelect: (date: dayjs.Dayjs) => void;
    onDateContinue: () => void;
    onPageChange: (date: string) => void;
    availabilitySlotsSelected: Date[] | undefined;
    isDisabled: boolean;
}

export const DateSelection = ({
    selectedProfessional,
    selectedDate,
    onDateSelect,
    onDateContinue,
    onPageChange,
    availabilitySlotsSelected,
    isDisabled,  
}: DateSelectionProps) => {
    const { translate } = useTranslation()
    const [showNoSlotsMessage, setShowNoSlotsMessage] = useState(false)

    const handleDateChange = (date: dayjs.Dayjs) => {
        // Check if there are available slots for the selected date
        const hasSlotsForDate = availabilitySlotsSelected?.some(slot =>
            dayjs(slot).isSame(date, 'day')
        )

        onDateSelect(date)
        if (hasSlotsForDate) {
            setShowNoSlotsMessage(false)
            onDateContinue()
        } else {
            setShowNoSlotsMessage(true)
        }
    }

    return (
        <div className={`flex flex-col ${isDisabled ? 'opacity-50 pointer-events-none' : ''}`}>
            {selectedProfessional && (
                <div className="mb-4 p-4 bg-base-200 rounded-lg">
                    <div className="flex items-center gap-3">
                        <img
                            src={selectedProfessional.user_professional_public.avatar_url || '/img/default-avatar.png'}
                            alt={selectedProfessional.user_professional_public.display_name || translate("page.appointments.professional.defaultAlt")}
                            className="w-12 h-12 rounded-full object-cover"
                        />
                        <div>
                            <h3 className="font-medium">{selectedProfessional.user_professional_public.display_name}</h3>
                            <p className="text-sm text-base-content/70">{translate(`pro-defs.${selectedProfessional.specialty}`)}</p>
                        </div>
                    </div>
                </div>
            )}


            <div className="flex-1">
                <Calendar
                    onPageChange={onPageChange}
                    onDateChange={(date) => handleDateChange(dayjs(date))}
                    selectedDate={selectedDate}
                    selectedDates={availabilitySlotsSelected}
                    className="w-full"
                />
            </div>

            {showNoSlotsMessage && (
                <div className="lg:hidden my-6 p-3 bg-warning/10 border border-warning/20 rounded-lg">
                    <p className="text-warning text-sm text-center">
                        {translate("page.appointments.no-slots")}
                    </p>
                </div>
            )}
        </div>
    )
} 